import { GAS_PRICE } from '@constants';
import { JsonRpcSigner } from '@ethersproject/providers';
import { toWei } from '@utils';
import { getLixiBagContract } from '../utils/getLixiBagContract';

export async function sendGasToMany(
  receivers: string[],
  signer: JsonRpcSigner,
  lixiBagAddress: string,
) {
  const contract = getLixiBagContract(lixiBagAddress, signer, true);
  return contract.sendGasToMany(receivers, {
    value: toWei(receivers.length * GAS_PRICE),
  });
}
